enum TicketPricingOption {
    SinglePrice = 'SinglePrice',
    GroupPricing = 'GroupPricing',
}

export default TicketPricingOption;
